// removed by extract-text-webpack-plugin
module.exports = {"crown":"crown___2qJ5m","crown-inner":"crown-inner___RNy0Z"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/LACrown/LACrown.scss
// module id = Oq/P
// module chunks = 60